var moduleMap = {
	"./filter-select": () => {
		return Promise.all(/* __federation_expose_filter_select */[__webpack_require__.e(96), __webpack_require__.e(642), __webpack_require__.e(884), __webpack_require__.e(238), __webpack_require__.e(661)]).then(() => (() => ((__webpack_require__(1913)))));
	},
	"./filter-input": () => {
		return Promise.all(/* __federation_expose_filter_input */[__webpack_require__.e(642), __webpack_require__.e(203), __webpack_require__.e(884), __webpack_require__.e(271)]).then(() => (() => ((__webpack_require__(4187)))));
	},
	"./document-list": () => {
		return Promise.all(/* __federation_expose_document_list */[__webpack_require__.e(96), __webpack_require__.e(642), __webpack_require__.e(203), __webpack_require__.e(884), __webpack_require__.e(238), __webpack_require__.e(522)]).then(() => (() => ((__webpack_require__(1442)))));
	},
	"./handlers": () => {
		return Promise.all(/* __federation_expose_handlers */[__webpack_require__.e(96), __webpack_require__.e(231), __webpack_require__.e(943)]).then(() => (() => ((__webpack_require__(712)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope, remoteEntryInitOptions) => {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};
// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});